import { api } from "./client";
import type { Procedure } from "./types";

export interface ProcedureFilters {
  search?: string;
  category?: string;
  isActive?: boolean;
}

export interface CreateProcedureData {
  name: string;
  description?: string;
  category?: string;
  duration: number;
  price: number;
  isActive?: boolean;
}

export const proceduresService = {
  async list(filters?: ProcedureFilters): Promise<Procedure[]> {
    return api.get<Procedure[]>("/procedures", filters);
  },

  async getCategories(): Promise<string[]> {
    return api.get<string[]>("/procedures/categories");
  },

  async getById(id: string): Promise<Procedure> {
    return api.get<Procedure>(`/procedures/${id}`);
  },

  async create(data: CreateProcedureData): Promise<Procedure> {
    return api.post<Procedure>("/procedures", data);
  },

  async update(id: string, data: Partial<CreateProcedureData>): Promise<Procedure> {
    return api.put<Procedure>(`/procedures/${id}`, data);
  },

  async delete(id: string): Promise<void> {
    return api.delete(`/procedures/${id}`);
  },
};
